"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _textfield = require("../textfield");

var _textfield2 = _interopRequireDefault(_textfield);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Stepper = function (_React$Component) {
  _inherits(Stepper, _React$Component);

  function Stepper(props) {
    _classCallCheck(this, Stepper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onIncrease = _this.onIncrease.bind(_this);
    _this.onDecrease = _this.onDecrease.bind(_this);
    return _this;
  }

  Stepper.prototype.onIncrease = function onIncrease() {
    this.props.onChange((parseInt(this.props.value) || 0) + 1);
  };

  Stepper.prototype.onDecrease = function onDecrease() {
    this.props.onChange((parseInt(this.props.value) || 0) - 1);
  };

  Stepper.prototype.render = function render() {
    var _props = this.props,
        _props$value = _props.value,
        value = _props$value === undefined ? 0 : _props$value,
        onChange = _props.onChange,
        className = _props.className,
        props = _objectWithoutProperties(_props, ["value", "onChange", "className"]);

    var prefixCls = "stepper";

    var componentCls = (0, _classnames2.default)(prefixCls, className);

    var buttonCls = prefixCls + "__button";
    var buttonWrapperCls = prefixCls + "__buttons";
    var inputCls = prefixCls + "__input";

    return _react2.default.createElement(
      "div",
      { className: componentCls },
      _react2.default.createElement(_textfield2.default, _extends({
        className: inputCls,
        type: "number",
        value: value,
        onChange: onChange
      }, props)),
      _react2.default.createElement(
        "div",
        { className: "stepper__buttons-wrapper" },
        _react2.default.createElement(
          "div",
          { className: buttonWrapperCls },
          _react2.default.createElement(
            "button",
            {
              type: "button",
              className: buttonCls,
              onMouseDown: this.onIncrease,
              "aria-label": "Increase"
            },
            "+"
          ),
          _react2.default.createElement(
            "button",
            {
              type: "button",
              className: buttonCls,
              onMouseDown: this.onDecrease,
              "aria-label": "Decrease"
            },
            "-"
          )
        )
      )
    );
  };

  return Stepper;
}(_react2.default.Component);

Stepper.propTypes = process.env.NODE_ENV !== "production" ? {
  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  onChange: _propTypes2.default.func,
  className: _propTypes2.default.string
} : {};

exports.default = Stepper;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/stepper/stepper.js
// module id = 1405
// module chunks = 249